export const payment = {
  id: undefined,
  date: '',
  value: null,
  act_id: '',
  account_code: '',
  type_id: 1,
  object_resources: [],
  description: '',
  roadmap_payments: []
}

export const paymentTypes = [
  { id: 1, name: 'Обычный платеж' },
  { id: 2, name: 'Авансовый платеж' },
  { id: 3, name: 'Взаимозачет' }
]
